import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import CloseButton from '../common/CloseButton';
import ModalButton from '../common/ModalButton';

import './PromptModal.scss';

const PromptModal = ({
  isOpen,
  onClose,
  primaryText,
  message,
  onPrimaryAction,
  secondaryText,
  onSecondaryAction,
  // More choices after the two, as [{ text, onClick }]. Each one closes the prompt.
  extraActions = [],
  autoCloseOnPrimary = true,
  isDestructive = false,
}) => {
  const { t } = useTranslation();

  useEffect(() => {
    if (!isOpen) return undefined;

    // Restored rather than unset, so a prompt over another modal leaves that modal's lock in place
    const previous = document.body.style.overflow;

    document.body.style.overflow = 'hidden';

    return () => {
      document.body.style.overflow = previous;
    };
  }, [isOpen]);

  if (!isOpen) return null;

  const handleBackdropClick = (e) => {
    if (e.target.className === 'PromptModal') {
      onClose();
    }
  };

  const handlePrimary = () => {
    onPrimaryAction();
    if (autoCloseOnPrimary) {
      onClose();
    }
  };

  const handleSecondary = () => {
    if (onSecondaryAction) {
      onSecondaryAction();
    } else {
      onClose();
    }
  };

  return (
    <div className="PromptModal" onClick={handleBackdropClick}>
      <div className="dialog">
        <div className="content">
          <div className="header">
            <h5 className="dialog-title">{t('common.confirm')}</h5>
            <CloseButton onClick={onClose} />
          </div>
          <div className="body">{typeof message === 'string' ? <span>{message}</span> : message}</div>
          {/* The way back on the left and the action on the right, like the permissions modal */}
          <div className="footer">
            <ModalButton variant="secondary" onClick={handleSecondary}>
              {secondaryText || t('common.cancel')}
            </ModalButton>
            <ModalButton variant={isDestructive ? 'danger' : 'primary'} onClick={handlePrimary}>
              {primaryText}
            </ModalButton>
            {extraActions.map(({ text, onClick }) => (
              <ModalButton
                key={text}
                variant="secondary"
                onClick={() => {
                  onClick();
                  onClose();
                }}
              >
                {text}
              </ModalButton>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PromptModal;
